import {Component, viewChild, AfterViewInit, Output, EventEmitter, ViewChild} from '@angular/core';
import { AppService } from 'src/app/app.service';
import { OrderService } from 'src/app/_services/order.service';

import * as _ from 'lodash';
import {LottieAnimationComponent} from "../../components/lottie-animation/lottie-animation.component";

@Component({
    selector: 'app-tabit-order-end',
    templateUrl: './tabit-order-end.component.html',
    styleUrl: './tabit-order-end.component.scss',
    standalone: false
})
export class TabitOrderEndComponent implements AfterViewInit {
	@ViewChild('endAnim', { static: false }) public endAnim: LottieAnimationComponent;
	@Output() onEndOrder = new EventEmitter<any>();

	itemsCollapsed = false;
	$storage;
	showAnimation;

	constructor(
		public appService: AppService,
		public orderService: OrderService,

	) {
		this.$storage = this.orderService.$storage;
	}

	runAnimation() {
		this.endAnim.playOnce([[0, 180]]);
	}

	ngAfterViewInit(ev?) {
		this.orderService.popMessages(this.$storage, 'afterOrder').then(() => {
			this.showAnimation = true;
		})
	}

	_restartOrder() {
		this.onEndOrder.emit('restart');
	}

	viewBill() {
		let url = `${this.appService.appConfig.tabitBillURL}/receipt?o=${this.appService.getOrganization()}&oid=${this.$storage.orderId}&p=&c=`
		window.open(url, '_blank');
	}
}

